import { Component, Input } from '@angular/core'
import { HelperService } from '../../../../../services/helper.service'
import { IDataCardBFGI } from '../../../../../models/data-card.model'
import { NotificationsModalComponent } from '../notifications-modal/notifications-modal.component'
import { NzModalService } from 'ng-zorro-antd/modal'

@Component({
    selector: 'app-data-binary-fg-ini',
    templateUrl: './data-binary-fg-ini.component.html',
    standalone: false
})
export class DataBinaryFgIniComponent {
  @Input() data: IDataCardBFGI
  @Input() hasCMMSPackage: boolean = false
  @Input() hasRCAFPackage: boolean = false

  constructor(private nzModalService: NzModalService) {}

  public getSIFParams(mo: string): any {
    return {
      filter: JSON.stringify(
        HelperService.getObjectWithoutNullValues({
          initiators: mo,
        }),
      ),
    }
  }

  public onOpenNotificationModal(tag: string, notifications?: number): void {
    if (!notifications) {
      return
    }

    this.nzModalService.create<NotificationsModalComponent, { mainObject: string }, any>({
      nzContent: NotificationsModalComponent,
      nzStyle: { top: '30px' },
      nzData: { mainObject: tag },
      nzNoAnimation: true,
    })
  }

  public hasUrlBadges(): boolean {
    return !!(
      this.data &&
      (this.data.Dev_Active ||
        this.data.Dev_InActive_Count ||
        this.data.Flt_Active ||
        this.data.Flt_InActive_Count ||
        this.data.Dmd_Active ||
        this.data.Dmd_InActive_Count ||
        this.data.Ovr_Active ||
        this.data.Ovr_InActive_Count)
    )
  }
}
